<template>
  <div
    class="gt-productpicker-plugin gt-productpicker-byproduct"
    v-show="master && master.activePlugin === id"
  >
    <el-form
      :model="form"
      ref="form"
      :label-width="master && master.labelWidth"
      :size="master && master.formSize"
      :disabled="master && master.disabled"
      @submit.native.prevent
    >
      <!-- 模式 -->
      <el-form-item
        v-if="importVisible.checkbox"
        :label="$t('Root.Picker.Method')"
        prop="method"
      >
        <el-radio-group v-model="form.method">
          <el-radio label="manual">{{ $t("Root.Picker.Manual") }}</el-radio>
          <el-radio label="import">{{ $t("Root.Picker.Import") }}</el-radio>
        </el-radio-group>
      </el-form-item>

      <!-- 手动选择 -->
      <el-form-item v-if="form.method === 'manual'">
        <!-- tips -->
        <div class="gt-productpicker-search-tips">
          <i class="el-icon el-icon-info"></i>
          <span>
            {{ $t("Root.Picker.Find_product_throung_search") }}
          </span>
        </div>

        <!-- searchbar -->
        <div class="gt-productpicker-searchbar">
          <div
            v-if="!setting.hiddenOrgPicker"
            :class="{
              'gt-productpicker-searchbar-org': true
            }"
          >
            <GtOrgTree
              :disabled="setting.orgPickerDisabled"
              v-model="searchForm.orgCode"
              @change="onOrgChange"
              custom-class="gt--reset"
              ref="orgTree"
            />
          </div>
          <div class="gt-productpicker-searchbar-main">
            <el-popover
              ref="popover"
              placement="bottom"
              width="400px"
              popper-class="gt-productpicker-popover"
              transition="el-zoom-in-top"
              trigger="manual"
              v-model="searchForm.searchPanelVisible"
            >
              <div
                class="gt-productpicker-result-table"
                v-loading="loading"
                v-click-outside="onClickOutside"
              >
                <el-scrollbar wrap-style="max-height: 320px;" tag="div">
                  <el-table
                    :data="dataList"
                    :show-header="false"
                    style="width: 100%"
                    empty-text="No data"
                  >
                    <!-- 单选模式下显示 -->
                    <el-table-column width="55px" v-if="singleMode">
                      <el-radio
                        slot-scope="{ row, row: { productCode }, $index: idx }"
                        v-model="selectedInSingleModel"
                        :label="productCode"
                        :disabled="
                          selectableCallback
                            ? !selectableCallback(row, idx)
                            : false
                        "
                      />
                    </el-table-column>

                    <!-- 多选模式下显示 -->
                    <el-table-column width="55px" v-else>
                      <el-checkbox
                        slot-scope="{ row, row: { productCode }, $index: idx }"
                        :value="selectedInMixModel"
                        @input="mixModelSwitch(row)"
                        :label="productCode"
                        :disabled="
                          selectableCallback
                            ? !selectableCallback(row, idx)
                            : false
                        "
                      />
                    </el-table-column>

                    <!-- image -->
                    <el-table-column width="60px" align="center">
                      <div
                        slot-scope="{ row }"
                        class="gt-productpicker-product-image"
                      >
                        <el-image :src="row.imagePlaceholder" fit="cover" />
                      </div>
                    </el-table-column>

                    <!-- name & code -->
                    <el-table-column width="400px">
                      <div
                        class="gt-productpicker-name-cell"
                        slot-scope="{
                          row: { productName: name, productCode: code }
                        }"
                      >
                        <p class="name">{{ name }}</p>
                        <p class="code">{{ code }}</p>
                      </div>
                    </el-table-column>
                  </el-table>
                </el-scrollbar>
                <div
                  class="gt-common__pagination gt-productpicker--reset"
                  v-show="dataList.length"
                >
                  <el-pagination
                    @current-change="handlePageChange"
                    :current-page="pageNum"
                    :total="total"
                    :pager-count="5"
                    layout="total, prev, pager, next, jumper"
                    small
                  >
                  </el-pagination>
                </div>
              </div>

              <el-input
                slot="reference"
                clearable
                :placeholder="$t('Root.Picker.Enter_product_name_to_search')"
                v-model="searchForm.searchString"
                @keypress.enter.native="handleSearch"
              >
                <i
                  slot="append"
                  class="el-icon-search"
                  @click="handleSearch"
                ></i>
              </el-input>
            </el-popover>
          </div>
        </div>

        <!-- 已选列表 -->
        <div class="gt-productpicker-selected">
          <div class="gt-productpicker-count">
            {{
              $t("Root.Picker.Selected_items", { total: form.selecteds.length })
            }}
          </div>
          <el-table :data="form.selecteds" style="width: 100%" height="334px">
            <el-table-column width="80px" align="center">
              <div slot-scope="{ row }" class="gt-productpicker-product-image">
                <el-image :src="row.imagePlaceholder" fit="cover" />
              </div>
            </el-table-column>

            <el-table-column
              prop="productCode"
              :label="$t('Root.Picker.Product_code')"
              width="150px"
            />

            <el-table-column
              prop="productName"
              show-overflow-tooltip
              :label="$t('Root.Picker.Product_name')"
            />

            <el-table-column
              prop="orgName"
              width="150px"
              show-overflow-tooltip
              :label="$t('Root.Picker.ORG')"
            />

            <el-table-column width="55px">
              <el-button
                type="text"
                slot-scope="{ $index: idx }"
                @click="handleDelete(idx)"
                icon="el-icon-delete"
              />
            </el-table-column>
          </el-table>
        </div>
      </el-form-item>

      <!-- 导入模式 -->
      <el-form-item v-show="importVisible.block">
        <div>
          <UploadBlock
            @change="onUploaderChange"
            template-url="http://static.gtech.asia/static/template/import-product.xlsx"
            :tips="$t('Root.Picker.You_can_select_produ')"
          />
          <section
            class="gt-productpicker-import-result"
            v-if="form.importeds && form.importeds.length"
          >
            <h5>{{ $t("Root.Picker.Imported_Products") }}</h5>
            <el-table :data="form.importeds" style="width: 100%" height="334px">
              <el-table-column
                prop="productCode"
                :label="$t('Root.Picker.Product_code')"
                width="150px"
              />

              <el-table-column
                prop="productName"
                show-overflow-tooltip
                :label="$t('Root.Picker.Product_name')"
              />
            </el-table>
          </section>
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import Vue from "vue";
import merge from "../mixins/merge.js";
import pagination from "../mixins/pagination.js";
import { mapActions, mapState } from "vuex";
import UploadBlock from "./children/UploadBlock.vue";
import { batchGetImagePlaceholder } from "../utils/getImagePlaceholder.js";
import objectPick from "../utils/objectPick.js";

export default {
  name: "ByProduct",

  mixins: [merge, pagination],

  components: {
    UploadBlock
  },

  data() {
    return {
      searchForm: {
        orgCode: "default",
        searchString: "",
        searchPanelVisible: false
      },

      form: {
        method: "manual",
        selecteds: [],
        importeds: []
      },

      rules: {
        required: {
          message: "Required",
          required: true
        }
      },

      // 数据请求的dataList
      dataList: [],

      loading: false
    };
  },

  computed: {
    // 单选模式下：被选中的商品的 productcode
    selectedInSingleModel: {
      get() {
        const { selecteds } = this.form;
        return selecteds && selecteds.length ? selecteds[0].productCode : "";
      },

      set(value) {
        if (!value) return;

        const target = this.dataList.find(
          ({ productCode: code }) => code === value
        );

        if (!target) return;

        this.$set(this.form.selecteds, 0, this.joinSelectedItem(target));
      }
    },

    // 多选模式下：被选中的商品的 productcode
    selectedInMixModel: {
      get() {
        const { selecteds } = this.form;
        return selecteds && selecteds.length
          ? selecteds.map(({ productCode }) => productCode)
          : [];
      },

      set(val) {
        // 由 this.mixModelSwitch 代理
      }
    },

    // 用于显隐"import"这个“checkbox”，和import这个区块
    importVisible() {
      // 单选模式 全部隐藏
      if (this.singleMode) {
        return {
          checkbox: false,
          block: false
        };
      } else {
        // 如果setting.importable为true 或者 undefined
        // 为undifined 代表默认显示
        if (
          this.setting.importable === undefined ||
          this.setting.importable === true
        ) {
          return {
            checkbox: true,
            // 此时block的显隐是根据用户选择控制的
            block: this.form.method === "import"
          };
        }
        // 如果setting.importable为false
        else {
          return {
            checkbox: false,
            block: false
          };
        }
      }
    },

    // selectableCallback
    // 一个计算属性 返回接受的porp中， setting 选项中是否有 setting.selectable 字段
    // setting.selectable 类型为 Function，Function 的返回值用来决定这一行的 CheckBox（or Radio） 是否可以勾选
    selectableCallback() {
      if (
        this.setting.selectable &&
        typeof this.setting.selectable === "function"
      ) {
        return this.setting.selectable;
      } else {
        return null;
      }
    }
  },

  methods: {
    ...mapActions("root/productPicker", ["queryProductList"]),

    // org change
    onOrgChange() {
      this.total = 0;
      this.dataList = [];
    },

    // search
    handleSearch(event) {
      this.handlePageChange(1);

      this.popoverVisibleToggle();

      event.stopPropagation();
    },

    // onClickOutside
    onClickOutside() {
      this.popoverVisibleToggle(false);
    },

    // delete item
    handleDelete(index) {
      this.form.selecteds.splice(index, 1);
    },

    // toggle
    popoverVisibleToggle(visible = true) {
      this.$set(this.searchForm, "searchPanelVisible", visible);
    },

    // 上传
    onUploaderChange(dataList) {
      if (!dataList.length) {
        this.$message.error(this.$t("Root.Picker.EmptyFile"));
        return;
      }
      // 判断 表格数据是否正确
      const { productCode, productName } = dataList[0];
      if (!productCode && !productName) {
        this.$message.error(this.$t("Root.Picker.upload_xlsx_err"));
        return;
      }
      this.$set(
        this.form,
        "importeds",
        // 筛选掉skuCode为空的数据
        // todo去重
        dataList.filter(({ productCode }) => !!productCode)
      );
    },

    // 已选的条目
    joinSelectedItem(data) {
      let { orgCode } = this.searchForm;
      let orgName = orgCode;

      if (!this.setting.hiddenOrgPicker) {
        let target = this.$refs.orgTree
          ? this.$refs.orgTree.getCurrentBind()
          : {};

        orgCode = target.orgCode || "";
        orgName = target.orgName || "";
      }

      return {
        ...data,
        orgCode,
        orgName
      };
    },

    // 多选模式下 选中的切换
    mixModelSwitch(val) {
      // 根据判断form.selecteds中是否已经存在 val
      let index = this.form.selecteds.findIndex(
        ({ productCode }) => productCode === val.productCode
      );

      if (index < 0) this.form.selecteds.unshift(this.joinSelectedItem(val));
      else this.form.selecteds.splice(index, 1);
    },

    // getData
    async getData() {
      if (this.loading) return;

      try {
        this.loading = true;
        const { pageSize, pageNum } = this;
        let { orgCode, searchString } = this.searchForm;
        // TODO: 希望组件支持默认查询具体参数的设置
        let { conditionListFn, defaultOrgCode } = this.setting;
        console.log(this.setting, "setting");
        if (defaultOrgCode) {
          orgCode = defaultOrgCode;
        }
        // TODO: 希望组件控制传入参数的粒度
        let searchConditionList = null;
        if (conditionListFn && typeof conditionListFn === "function") {
          searchConditionList = conditionListFn(searchString);
        }
        const { dataList, total } = await this.queryProductList({
          pageInput: {
            pageSize,
            pageNum
          },
          orgCode,
          searchString,
          searchConditionList
        });

        this.total = total;
        this.dataList = batchGetImagePlaceholder(dataList);
      } catch (err) {
        console.error(err);
      } finally {
        this.loading = false;
      }
    },

    // 用于required的验证
    // 通过判断未选择商品 reject
    // 通过判断已选择了商品 resolve
    requiredValidator() {
      const { selecteds, importeds } = this.form;

      if (!selecteds.length && !importeds.length) {
        return false;
      } else {
        return true;
      }
    },

    // todo deepCopy
    // 对提交的数据的改造
    dataCustomize(next) {
      const { method } = this.form;
      const { objectPicks } = this.setting;

      // 如果是单选模式 只需要取数组的第一项
      const originData =
        method === "manual"
          ? this.singleMode
            ? this.form.selecteds.slice(0, 1)
            : this.form.selecteds
          : this.form.importeds;
      const nextParams = {
        method,
        // 排除掉多余的字段
        selecteds:
          objectPicks && objectPicks.length > 0
            ? originData.map(el => objectPick(el, objectPicks))
            : originData.map(
                ({
                  productCode,
                  productName,
                  mediaLink = "",
                  orgCode,
                  orgName,
                  productType,
                  status
                }) => {
                  return {
                    productCode,
                    productName,
                    mediaLink,
                    orgCode,
                    orgName,
                    productType,
                    status
                  };
                }
              )
      };
      next(nextParams);
    },

    // 将使用者传入的数据 初始化 改造等操作
    // 在mimix: merge, 中有默认的mergeInit 方法
    // 如果默认的 mergeInit 方法不符合需求
    // 这里自定义 mergeInit 即可覆盖
    mergeInit(data) {
      const { selecteds, importeds } = data;

      // 产品经理的需求： 编辑时候，method 默认回到 manual
      this.$set(this.form, "method", "manual");
      this.$set(
        this.form,
        "selecteds",
        // batchGetImagePlaceholder 是用于处理图片的方法
        batchGetImagePlaceholder(selecteds || importeds || [])
      );
    }
  }
};
</script>

<style lang="scss">
// .gt-productpicker-byproduct {
//   .gt-org-tree__reference-label {
//     height: 40px;
//     line-height: 40px;
//   }

//   .el-input__inner {
//     height: 40px;
//     line-height: 40px;
//     border-radius: 0px !important;
//     border: 1px solid #dfe4ed;
//   }
// }
</style>
